"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MANUAL_PLAY_TIME = 0.23;

var ManualPlayHandler = function ManualPlayHandler(_ref) {
  var _this = this;

  var stateSelector = _ref.stateSelector,
      handleOverrideCurrentTime = _ref.handleOverrideCurrentTime;

  _classCallCheck(this, ManualPlayHandler);

  _defineProperty(this, "attemptStart", function () {
    if (_this._playInterval) {
      return;
    }

    _this._playInterval = setInterval(function () {
      if (!_this._playInterval) {
        return;
      }

      var _this$playerStateSele = _this.playerStateSelector(),
          currentClip = _this$playerStateSele.currentClip,
          currentTime = _this$playerStateSele.currentTime,
          playing = _this$playerStateSele.playing,
          totalDuration = _this$playerStateSele.totalDuration;

      var timeIsPastTheEnd = currentTime >= totalDuration;
      var isVideoClip = !currentClip.isEmpty && !currentClip.isImage && currentClip.isTranscoded;

      if (_this._playInterval && (timeIsPastTheEnd || isVideoClip || !playing)) {
        clearInterval(_this._playInterval);
        _this._playInterval = null;
        return;
      } // TODO UPDATE VALUES TO HANDLE FF


      var overriddenTime = currentTime + MANUAL_PLAY_TIME > totalDuration ? totalDuration : currentTime + MANUAL_PLAY_TIME;

      _this.handleOverrideCurrentTime(overriddenTime, {
        skipPause: overriddenTime !== totalDuration
      });
    }, MANUAL_PLAY_TIME * 1000);
  });

  this.playerStateSelector = stateSelector;
  this.handleOverrideCurrentTime = handleOverrideCurrentTime;
};

exports.default = ManualPlayHandler;